var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64964 5.85441L0.644643 1.82324C0.451786 1.62912 0.451786 1.31206 0.644643 1.11794L1.11393 0.645588C1.30679 0.451471 1.62179 0.451471 1.81464 0.645588L4.99679 3.84206L8.18536 0.645588C8.37821 0.451471 8.69321 0.451471 8.88607 0.645588L9.35536 1.11794C9.54821 1.31206 9.54821 1.62912 9.35536 1.82324L5.34393 5.85441C5.15107 6.04853 4.8425 6.04853 4.64964 5.85441Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDownArrow);
export default __webpack_public_path__ + "static/media/FilterDownArrow.cacd6ab80c76a36e6528b7afe7021954.svg";
export { ForwardRef as ReactComponent };